// extracted by mini-css-extract-plugin
export default {"page":"XP","top_block":"YP","heading":"ZP","inner_text":"aQ","starter_text":"bQ","starter_cta":"cQ","summary_block":"eQ","cartsummary_wrap":"fQ","price":"gQ","pricing_wrap":"hQ","summary_block_mob":"iQ","summary":"jQ","pricing_heading":"kQ","products_summary":"lQ","summary_line":"mQ","summary_price":"nQ","summary_title":"oQ"};
    if(module.hot) {
      // 1721922365249
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  